<template>
    <div
    v-if="contentImage.length === 2"
    class="content-image-double"
    >

        <div
        v-for="(item, index) in contentImage"
        :key="index"
        class="content-image-double-item"
        >
            
            <img
            v-if="item.image"
            :src="getImage(index)" alt="image">

            <!-- <ImageTopLabel
            v-if="item.topLabel"
            :textTopLabel = item.topLabel
            /> -->

            <ImageBottomLabel
            v-if="item.bottomLabel"
            :textBottomLabel = item.bottomLabel
            />

            <ImageBottomLabelSecond
            v-if="item.secondBottomLabel"
            :textBottomLabel = item.secondBottomLabel
            />
        </div>    

    </div>
    <div
        v-else-if="contentImage.length === 1"
        class="content-image-single"
    >
        <div 
        :class="{'image-width-100-percent': contentImage[0].imageWidthPercent===100,
                'image-width-30-percent': contentImage[0].imageWidthPercent===30,
                }"
        class="image-single"
        >
            <img
            v-if="contentImage[0].image"
            :src="getImage(0)" alt="image" 
            >

            <!-- <ImageTopLabel
            v-if="contentImage[0].topLabel"
            :textTopLabel = contentImage[0].topLabel
            /> -->
            
            <ImageBottomLabel
            v-if="contentImage[0].bottomLabel"
            :textBottomLabel = contentImage[0].bottomLabel
            />
            
        </div>
        
    </div>

</template>
  
<script>

// import ImageTopLabel from '@/components/game/ImageTopLabel.vue'
import ImageBottomLabel from '@/components/game/ImageBottomLabel.vue'
import ImageBottomLabelSecond from '@/components/game/ImageBottomLabelSecond.vue'

export default {
    name: 'InfoImage',
    components: {
        // ImageTopLabel,
        ImageBottomLabel,
        ImageBottomLabelSecond
    },
    props: {
        contentImage: []
    },
    methods: {
        getImage(index) {
            return require(`@/assets/images/${this.contentImage[index].image}`)
        }
    }    
}
</script>
  
<style>

</style>
  